import { SiafLiteApiRepository } from "../../external";
import store from "../../config/store";

class DreService {
  constructor() {
    this.urlBase = "faturamento/dre";
    this.urlBaseCompleta = `${store.baseUrl}/${this.urlBase}`;
  }

  getReceitaMensal(body) {
    return new SiafLiteApiRepository(`${this.urlBase}/receita-mensal`).patch(body);
  }
}

export default DreService;
